<template>
  <sf-dialog v-model="dialog">
    <template #activator="slotData">
      <slot name="activator" v-bind="slotData" />
    </template>
    <v-card>
      <v-card-item>
        <v-card-title>
          <sf-heading>{{ title }}</sf-heading>
        </v-card-title>
      </v-card-item>
      <v-card-text>
        <slot name="content" />
      </v-card-text>
    </v-card>
  </sf-dialog>
</template>

<script setup lang="ts">
import SfDialog from '@/components/dialog/SfDialog.vue'
import SfHeading from '@/components/text/SfHeading.vue'
import { ref } from 'vue'

defineProps({
  title: {
    type: String,
    required: true
  }
})

const dialog = ref(false)
</script>
